import service from '@/service'
const base =
  '/scm/purchaseWarehouse/warehouseEntryReceipts/defectiveRegistration'
export const registerDefective = (data) =>
  service['api-scm']({ url: `${base}/save`, method: 'post', data })
export const getDefectiveRecords = (receiptId) =>
  service['api-scm']({
    url: `${base}/records`,
    method: 'get',
    params: { receiptId }
  })
export const getDefectiveCases = () =>
  service['api-scm']({ url: `${base}/cases`, method: 'get' })
